import MobileDetect from "mobile-detect"

;(() => {
  const mobileDetect = new MobileDetect(window.navigator.userAgent)
  const isTouchScreen =
    !!mobileDetect.mobile() || !!mobileDetect.tablet() || !!mobileDetect.phone()

  const openClass = "cart-dropdown-open"

  window.addEventListener("DOMContentLoaded", () => {
    const cart = document.querySelector(".header__cart")

    if (!cart || !cart.querySelector(".cart-dropdown")) {
      return
    }

    const toggle = cart.querySelector(".header__configurator-button")

    if (isTouchScreen) {
      toggle.addEventListener("click", (e) => {
        e.preventDefault()
        cart.classList.toggle(openClass)
      })

      document.addEventListener("click", (e) => {
        if (!cart.contains(e.target)) {
          cart.classList.remove(openClass)
        }
      })
    } else {
      toggle.addEventListener("mouseenter", () => {
        cart.classList.add(openClass)
      })

      cart.addEventListener("mouseleave", () => {
        cart.classList.remove(openClass)
      })
    }
  })
})()
